import React from "react";
import { Icon, WrappingIconProps } from "../Icon";

export const BlackfireIcon = (props: WrappingIconProps) => {
  return (
    <Icon width="32" height="32" viewBox="-4 -4 32 32" fill="none" {...props}>
      <path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill="#E03C31"
      />
      <path
        d="M9.87422 20.1396C10.0141 20.3355 9.84625 20.5872 9.62246 20.5312C5.67842 19.9998 2.8812 14.1816 6.54555 10.825C10.6015 7.10469 11.5246 4.8949 11.049 3.72008C10.9931 3.55225 11.1329 3.41239 11.2728 3.46834C12.6155 4.13966 15.6644 6.15365 14.6574 10.5173C14.6574 10.5173 16.4197 10.4893 16.4756 8.83897C16.4756 8.67113 16.6714 8.61518 16.7833 8.69911C17.5385 9.3984 19.4127 11.4124 19.1609 14.0697C18.7973 17.9299 16.14 19.9438 14.1819 20.4194C13.9861 20.4753 13.8183 20.2515 13.9302 20.0837C14.4896 19.2445 15.4966 17.5382 13.3987 15.8599C11.8323 14.6851 11.6365 13.4543 11.8602 12.6991C11.8882 12.5592 11.7483 12.4753 11.6644 12.5592C7.63646 15.9718 9.091 19.0208 9.87422 20.1396Z"
        fill="var(--theme-neutral-0)"
      />
    </Icon>
  );
};
